import { DEVICE_ID, SETTINGS_PREFIX, TRACKER_PREFIX } from "../constants.js";

/** Class that stores key/value pairs in localStorage if possible
    but falls back to sessionStorage. */
export class LocalStorageStore {
  constructor(config) {
    this.prefix = config.prefix || "cassis-reader";
    try {
      // In some browsers (eg iOS Safari in private mode),
      // localStorage exists but throws an exception when
      // you try to write to it.
      const testKey = `${config.prefix}-${String(Math.random())}`;
      window.localStorage.setItem(testKey, "test");
      window.localStorage.removeItem(testKey);
      this.storage = window.localStorage;
      this.fallbackStore = null;
      // This catch condition is basically impossible to test using the current test framework.
      /* c8 ignore next 4 */
    } catch (e) {
      console.error("LocalStorage not available: ", e);
      this.storage = window.sessionStorage;
    }
  }

  getLocalStorageKey(key) {
    return `${this.prefix}-${key}`;
  }

  // async getKey(key) {
  // 	return this.getKeySync(key);
  // }

  getKeySync(key) {
    return this.storage.getItem(this.getLocalStorageKey(key)) || null;
  }

  // async setKey(key, value) {
  // 	return this.setKeySync(key, value);
  // }

  async setKeySync(key, value) {
    return this.storage.setItem(this.getLocalStorageKey(key), value);
  }

  // async remove(key) {
  // 	return this.removeSync(key);
  // }
  async removeKeySync(key) {
    return this.storage.removeItem(this.getLocalStorageKey(key));
  }
}

// The constructor takes a config object; these used to pass the bare
// string, so both stores fell back to "cassis-reader" and the device id
// did not match the one the EPUB reader keeps under "cassis-tracker".
export const settingsStore = new LocalStorageStore({ prefix: SETTINGS_PREFIX });
export const trackerStore = new LocalStorageStore({ prefix: TRACKER_PREFIX });

// This ensures that bookmarks are scoped to just the current PDF.
const currentURL = new URL(window.location.href);
currentURL.search = "";
currentURL.hash = "";
export const bookStore = new LocalStorageStore({
  prefix: currentURL.href,
});
let deviceId = trackerStore.getKeySync(DEVICE_ID);

if (deviceId === null) {
  deviceId = window.crypto.randomUUID();
  trackerStore.setKeySync(DEVICE_ID, deviceId);
}

export const device = {
  id: deviceId,
};

// Export bookStore that binds to a signal for the manifest URL
